import React, { useEffect, useState } from 'react';
import { GeneralDialog } from 'sharedComponents/GeneralDialog';
import { useTranslation } from 'react-i18next';
import { IconInfoFilled } from 'svgIcons/MotionPortalIcons';
import colors from 'theme/_colors.scss';
import './style.scss';
import PropTypes from 'prop-types';
import { apiCallStatus } from 'helpers/constants';

const DeleteAssetComponent = ({ show, close, asset, gatewayID, onResetAssetInfo, actions, model }) => {
    const { t: translate } = useTranslation();
    const [isDeleting, setIsDeleting] = useState(false);
    const deleteAsset = model?.deleteAsset;

    // Close dialog only on successful deletion
    useEffect(() => {
        if (isDeleting && deleteAsset?.loadingStatus === apiCallStatus.SUCCESS) {
            setIsDeleting(false);
            close();
        }
        // ErrorBoundary will catch ERROR status via withErrorBoundaryTrigger
    }, [deleteAsset, isDeleting, close]);

    const handleDelete = () => {
        setIsDeleting(true);
        actions.deleteAssetRequest(asset?.assetId, gatewayID, onResetAssetInfo);
    };

    const content = <div className='delete_asset_dialog__content'>
        <div>{translate('ABB.Powertrain.Frontend.DeleteAssetDiscription')}</div>
    </div>;
    const getDeleteGatewayTitle = <h1 className='delete_asset_dialog__title'>
        <IconInfoFilled color={colors.primaryInfo} />
        <span className='delete_asset_dialog__title-text'>{translate('ABB.Powertrain.Frontend.DeleteAssetTitle')}</span>
    </h1>;
    return (
        <GeneralDialog
            show={show}
            id='delete-asset-dialog'
            close={close}
            dialogClassName='delete_asset_dialog'
            closeButton={true}
            title={getDeleteGatewayTitle}
            cancelButtonProps={{
                text: translate('ABB.Powertrain.Frontend.cancelLabel'),
            }}
            acceptButtonProps={{
                text: translate('ABB.Powertrain.Frontend.deleteLabel'),
                onClick: handleDelete,
                disabled: isDeleting
            }}
            persistent={false}
        >
            {content}
        </GeneralDialog>
    );
};
DeleteAssetComponent.propTypes = {
    show: PropTypes.bool,
    close: PropTypes.func,
    gatewayID: PropTypes.any,
    asset: PropTypes.object,
    onResetAssetInfo: PropTypes.func,
    actions: PropTypes.shape({
        deleteAssetRequest: PropTypes.func,
    }),
    model: PropTypes.shape({
        deleteAsset: PropTypes.object,
    }),
};
export default DeleteAssetComponent;
